const classes = {
  containerModifierClass: "o-carousel-",
  slideClass: "o-carousel-slide",
  slideActiveClass: "-active",
  slideVisibleClass: "-visible",
  slideNextClass: "-next",
  slidePrevClass: "-prev",
  wrapperClass: "o-carousel-wrapper",
};

export default classes;



// WEBPACK FOOTER //
// ./scripts/util/swiperClasses.js